import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [logoSrc, setLogoSrc] = useState('/logonew.png');
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuItems = [
    { path: '/', label: 'Home', color: 'var(--primary-gold)' },
    { path: '/about', label: 'About', color: 'var(--accent-blue)' },
    { path: '/services', label: 'Services', color: 'var(--accent-teal)' },
    { path: '/practice-areas', label: 'Practice Areas', color: 'var(--accent-purple)' },
    { path: '/contact', label: 'Contact', color: 'var(--accent-orange)' }
  ];

  return (
    <header className={`header ${isScrolled ? 'header-scrolled' : ''}`}>
      <div className="header-container">
        <div className="nav-wrapper">
          <Link to="/" className="logo" onClick={() => setIsMenuOpen(false)}>
            <img
              src={logoSrc}
              onError={() => setLogoSrc('/logo.png')}
              alt="Ambreen Daudpota - Advocate High Court"
              className="logo-image"
              loading="eager"
              decoding="async"
            />
          </Link>
          
          <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
            {menuItems.map((item, index) => (
              <Link
                key={item.path}
                to={item.path}
                className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                style={{ '--menu-color': item.color }}
                onClick={() => setIsMenuOpen(false)}
              >
                {item.label}
              </Link>
            ))}
          </nav>
          
          <div className="header-actions">
            <Link to="/contact" className="btn btn-header">
              Free Consultation
            </Link>
            <button 
              className="menu-toggle"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Toggle menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
